module.exports = __webpack_public_path__ + "media/images/site-logo-89e87222.png";